import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getMessaging } from "firebase/messaging"; // 👈 AÑADIR ESTO

const firebaseConfig = {
  apiKey: "AIzaSyDO1GQ1CKjJgPzP-W5fMgoPTrWwvhVmnB0",
  authDomain: "authentication-8fc98.firebaseapp.com",
  projectId: "authentication-8fc98",
  storageBucket: "authentication-8fc98.firebasestorage.app",
  messagingSenderId: "663976638195",
  appId: "1:663976638195:web:7513441e03eb48d1096986",
  measurementId: "G-RLW292RN2S"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const providerKeycloak = new OAuthProvider("oidc.keycloakniam");

provider.setCustomParameters({ prompt: "select_account" });
providerKeycloak.setCustomParameters({ prompt: "select_account" });

const messaging = getMessaging(app); // 👈 AÑADIR ESTO

export { auth, provider, providerKeycloak, messaging };